import React from 'react'
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";

const PersonalInfoDetails = ({ formData }) => {

    useGSAP(() => {
        const fields = document.querySelectorAll(".relative");

        fields.forEach((field) => {
            const input = field.querySelector("input, select");
            const label = field.querySelector("label");
            const pLabel = field.querySelector("p"); // Error message <p> element (optional)

            if (!input || !label) {
                console.warn("Missing input or label in field:", field);
                return; // Skip this field if input or label is missing
            }

            // Automatically move label to the top if the input already has a value
            if (input.value !== "") {
                gsap.to(label, { top: -10, fontSize: "0.70rem", color: "#6b7280", duration: 0.25 }); // Set label to gray initially
                gsap.to(input, { borderColor: "#6b7280", duration: 0.25 }); // Set border to gray initially
                if (pLabel) {
                    pLabel.textContent = `Please enter your ${label.textContent.toLowerCase()}`;
                    pLabel.classList.remove("text-red-500");
                    pLabel.classList.add("text-gray-500");
                }
            }
        })

    }, [formData])


    return (
        <div>
            <h2 className="text-gray-800 text-lg font-semibold mb-4">Personal Info </h2>  
            {/* User Image */}
            <div className="mb-6">
                <img src={formData?.profileURL ? formData.profileURL : "/Assets/default_user.png"} alt="User Profile" className="w-28 h-28 border border-gray-300" />
            </div>

            {/* First Row of Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                {/* Title */}
                <div className="relative">
                    <label htmlFor="title" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Title * </label>
                    <input
                        id="title"
                        name="title"
                        value={formData.title}
                        className="w-full p-2 border rounded border-[#6b7280]"
                        readOnly
                    />

                </div>

                {/* Full Name */}
                <div className="relative">
                    <label htmlFor="fullName" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Full Name * </label>
                    <input
                        id="fullName"
                        name='fullName'
                        value={formData.fullName}
                        type="text"
                        className="w-full p-2 border rounded border-[#6b7280]"
                        readOnly
                    />

                </div>

                {/* Father's Name */}
                <div className="relative">
                    <label htmlFor="fatherName" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Father's Name * </label>
                    <input
                        id="fatherName"
                        name='fatherName'
                        value={formData.fatherName}
                        type="text"
                        className="w-full p-2 border rounded border-[#6b7280]"
                        readOnly
                    />

                </div>

            </div>

            {/* Second Row of Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">

                {/* Marital Status */}
                <div className="relative">
                    <label htmlFor="maritalStatus" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Marital Status * </label>
                    <input
                        id="maritalStatus"
                        name="maritalStatus"
                        value={formData.maritalStatus}
                        className="w-full p-2 border rounded border-[#6b7280]"
                        readOnly
                    />

                </div>

                {/* Gender */}
                <div className="relative">
                    <label htmlFor="gender" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Gender * </label>
                    <input
                        id="gender"
                        name="gender"
                        value={formData.gender}
                        className="w-full p-2 border rounded border-[#6b7280] bg-white"
                        readOnly
                    />

                </div>

                {/* Date Of Birth */}
                <div className="relative">
                    <label htmlFor="dateOfBirth" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Date Of Birth * </label>
                    <input
                        id="dateOfBirth"
                        name='dateOfBirth'
                        type="date"
                        value={formData.dateOfBirth}
                        className={`w-full p-2 border rounded border-[#6b7280] ${!formData.dateOfBirth && 'text-transparent'}`}
                        readOnly
                    />

                </div>

                {/* CNIC */}
                <div className="relative">
                    <label htmlFor="cnic" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">CNIC * </label>
                    <input
                        id="cnic"
                        name='cnic'
                        type="text"
                        value={formData.cnic}
                        className={`w-full p-2 border rounded border-[#6b7280]`}
                        readOnly
                    />

                </div>

                {/* Cell Phone */}
                <div className="relative">
                    <label htmlFor="cellPhone" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Phone Number * </label>
                    <input
                        id="cellPhone"
                        name='cellPhone'
                        type="text"
                        value={formData.cellPhone}
                        className={`w-full p-2 border rounded border-[#6b7280]`}
                        readOnly
                    />

                </div>

                {/* Email */}
                <div className="relative">
                    <label htmlFor="email" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Email * </label>
                    <input
                        id="email"
                        name='email'
                        type="text"
                        value={formData.email}
                        className={`w-full p-2 border rounded border-[#6b7280]`}
                        readOnly
                    />

                </div>

                <div className="relative">
                    <label htmlFor="passportNumber" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Passport Number * </label>
                    <input
                        id="passportNumber"
                        name="passportNumber"
                        value={formData.passportNumber}
                        className="w-full p-2 border rounded border-[#6b7280] bg-white"
                        readOnly
                    />

                </div>

                <div className="relative">
                    <label htmlFor="nationality" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">Nationality * </label>
                    <input
                        id="nationality"
                        name="nationality"
                        value={formData.nationality}
                        className="w-full p-2 border rounded border-[#6b7280] bg-white"
                        readOnly
                    />

                </div>

                {/* City of residence */}
                <div className="relative">
                    <label htmlFor="cityOfResidence" className="absolute text-sm text-gray-500 transform top-2 left-3 bg-white px-1">City Of Residence * </label>
                    <input
                        id="cityOfResidence"
                        name='cityOfResidence'
                        type="text"
                        value={formData.cityOfResidence}
                        className={`w-full p-2 border rounded border-[#6b7280]`}
                        readOnly
                    />

                </div>
            </div>
        </div>
    )
}

export default PersonalInfoDetails